import { OnDestroy, Injector, Injectable } from '@angular/core';
import { ReportParamsTransformer } from '@content-platform/web-angular-shared-util-error-handling';
import { Subscription } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { getADUser } from './auth/auth.selectors';
@Injectable()
export class AuthReportTransformer extends ReportParamsTransformer implements OnDestroy {
  private user: adal.User;
  private subscriptions: Subscription[] = [];

  constructor(protected injector: Injector) {
    super(injector);
  }

  initialize() {
    const store = this.injector.get(Store);
    this.subscriptions.push(store.pipe(select(getADUser)).subscribe((user) => (this.user = user)));
  }

  getParams() {
    return {
      'User Name': this.user ? this.user.userName : undefined,
    };
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }
}
